var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePrimaryBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2635,
    cy: 16.707,
    r: 10,
    transform: "rotate(-45 16.2635 16.707)",
    fill: "#FDFDFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2897 20.8608L12.4999 14.0709L13.8508 12.72L20.6407 19.5098L19.2897 20.8608ZM13.8508 20.8557L12.4999 19.5048L19.2897 12.715L20.6407 14.0659L13.8508 20.8557Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePrimaryBackWhite);
export default __webpack_public_path__ + "static/media/close_primary_back_white.1e80e78b72a157b4e66a506e4e9f3700.svg";
export { ForwardRef as ReactComponent };